import { PropTypes } from 'react';

export const messagePropTypes = PropTypes.shape({
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  type: PropTypes.string.isRequired,
});

export const surveyAdditionalDataPropTypes = PropTypes.shape({
  additionalDataId: PropTypes.string.isRequired,
  isMandatory: PropTypes.bool.isRequired,
  order: PropTypes.number.isRequired,
  additionalDataType: PropTypes.string.isRequired,
  labelQuestion: PropTypes.string.isRequired,
});



// WEBPACK FOOTER //
// ./components/chat/propTypes.js